module.exports = __webpack_public_path__ + "img/rotten_tomato.b1ba2949.png";